import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Modo oscuro del portal: persistido, global, sin backend. `theme` guarda la PREFERENCIA
 * ('light'|'dark'|'system'); `isDark` es el valor YA RESUELTO que consume el DOM (`main.jsx` aplica la
 * clase `.dark` en `<html>` antes del primer render para evitar parpadeo, este store la mantiene
 * sincronizada después). Con 'system' sigue al sistema operativo EN VIVO (`escucharSistema`).
 */
const consulta = () =>
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

const prefiereOscuro = () => !!consulta()?.matches;

// Color de la barra del navegador en el teléfono: sigue al tema elegido, no solo al del sistema.
const COLOR_BARRA = { claro: '#FAF9F7', oscuro: '#0B1220' };

const aplicarClaseDom = (isDark) => {
    if (typeof document === 'undefined') return;
    document.documentElement.classList.toggle('dark', isDark);
    document.querySelectorAll('meta[name="theme-color"]').forEach((m) => {
        m.setAttribute('content', isDark ? COLOR_BARRA.oscuro : COLOR_BARRA.claro);
    });
};

const resolver = (theme) => theme === 'dark' || (theme === 'system' && prefiereOscuro());

export const useThemeStore = create(
    persist(
        (set, get) => ({
            theme: 'system',
            isDark: prefiereOscuro(),
            setTheme: (theme) => {
                const isDark = resolver(theme);
                aplicarClaseDom(isDark);
                set({ theme, isDark });
            },
            toggleTheme: () => {
                get().setTheme(get().isDark ? 'light' : 'dark');
            },
        }),
        {
            name: 'coredesk-partner-theme',
            partialize: (s) => ({ theme: s.theme }),
            onRehydrateStorage: () => (state) => {
                if (!state) return;
                const isDark = resolver(state.theme);
                aplicarClaseDom(isDark);
                state.isDark = isDark;
            },
        }
    )
);

/** Mientras la preferencia sea «Sistema», cambia de tema cuando cambia el del sistema operativo. */
export function escucharSistema() {
    const mq = consulta();
    if (!mq) return () => {};
    const alCambiar = () => {
        const { theme, setTheme } = useThemeStore.getState();
        if (theme === 'system') setTheme('system');
    };
    mq.addEventListener?.('change', alCambiar);
    return () => mq.removeEventListener?.('change', alCambiar);
}
